import { useEffect } from 'react'

/**
 * @desc  visibilitychange 이벤트를 관리하는 Hook
 *
 * @param {boolean} isActive  해당 훅에서 로직 실행 여부.
 * @param {function} onVisible  visible 상태일 때 실행될 콜백 함수.
 *
 * */
const useVisibilityChange = ({ isActive = true, onVisible }) => {
  useEffect(() => {
    if (isActive) {
      const handleVisibility = () => {
        if (document.visibilityState === 'visible') {
          onVisible()
        }
      }
      document.addEventListener('visibilitychange', handleVisibility)
      return () => {
        document.removeEventListener('visibilitychange', handleVisibility)
      }
    }
  }, [isActive, onVisible])
}

export default useVisibilityChange
